import { PhoneNumberUtil } from "google-libphonenumber";
export function parsePhoneNumberIfDefined(
  defaultCountry: string,
  pn?: string,
):
  | {
      dialCode: string;
      countryCode: string;
      number: string;
    }
  | undefined {
  if (!pn) return undefined;
  const phoneUtil = PhoneNumberUtil.getInstance();
  const parsed = phoneUtil.parse(pn, defaultCountry);
  const number = parsed.getNationalNumber();
  if (!number) {
    console.warn("Invalid phone number", pn);
    return undefined;
  }

  const region = phoneUtil.getRegionCodeForCountryCode(
    parsed.getCountryCodeOrDefault(),
  );
  if (!region) {
    console.warn("Region not found for phone number", pn);
    return undefined;
  }
  return {
    dialCode: parsed.getCountryCodeOrDefault().toString(),
    countryCode: region,
    number: number.toString(),
  };
}
